import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { bindActionCreators } from "redux";

import { withStyles } from "@mui/styles";

import ConfirmMessageDialog from "../../../../components/ConfirmMessageDialog";
import { myEmployeeActions } from "../../../../actions";
import Util from "../../../../utils/Util";

import EmployeeEditDialog from "../../components/Quote/components/EmployeeDialogForm/EmployeeEditDialog";

import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

const TIPS_CODE = {
  BASIC: "BASIC",
  CHANGE_CATEGORY: "CHANGE_CATEGORY",
  TERMINATE_DEPENDENT: "TERMINATE_DEPENDENT"
};

const MODE = {
  ADD: "ADD",
  EDIT: "EDIT"
};

class MyEmployeeDialog extends Component {
  constructor(props) {
    super(props);

    this.submitData = null;
    this.originalValues = null;
    this.state = {
      value: 0, // first tab : Employee Detail
      confirmSubmitDialog: false,
      tips: [],
      systemEmailExist: false,
      inlineError: null,
      serverErrorDialog: false,
      serverErrorMessage: null,
      dependantConfirmDialog: false,
      dependantsWithEndDate: []
    };
  }

  componentWillMount() {
    const { selectedRecord } = this.props;
    this.setOriginalValues(selectedRecord);
    this.setTips(TIPS_CODE.BASIC);
  }

  setOriginalValues = selectedRecord => {
    if (selectedRecord) {
      this.originalValues = {
        category: selectedRecord.category
      };
    }
  };

  setTips = (code, add = true) => {
    const { intl, policyDetails } = this.props;
    let tips = Util.clone(this.state.tips) || [];
    let exists = this.state.tips.filter(t => t.code === code).length > 0;
    if (exists) {
      if (!add) {
        tips = tips.filter(t => t.code !== code);
      }
    } else {
      if (add) {
        if (code === TIPS_CODE.BASIC) {
          if (policyDetails?.policy?.renewal_submitted) {
            tips.push({
              code: TIPS_CODE.BASIC,
              multiTip: true,
              title: "Tips:",
              content: [
                intl.formatMessage({
                  id: "hr.myemployee.tips.warning.basic4"
                })
              ]
            });
          } else {
            tips.push({
              code: TIPS_CODE.BASIC,
              multiTip: true,
              title: "Tips:",
              content: [
                intl.formatMessage({
                  id: "hr.myemployee.tips.warning.basic"
                }),
                intl.formatMessage({
                  id: "hr.myemployee.tips.warning.basic2"
                }),
                intl.formatMessage({
                  id: "hr.myemployee.tips.warning.basic3"
                })
              ]
            });
          }
        }

        if (code === TIPS_CODE.CHANGE_CATEGORY) {
          tips.push({
            code: TIPS_CODE.CHANGE_CATEGORY,
            title: "Requirement:",
            content: intl.formatMessage({
              id: "hr.myemployee.tips.warning.changeCategory"
            })
          });
        }

        if (code === TIPS_CODE.TERMINATE_DEPENDENT) {
          tips.push({
            code: TIPS_CODE.TERMINATE_DEPENDENT,
            title: "Requirement:",
            content: intl.formatMessage({
              id: "hr.myemployee.tips.warning.terminateDependent"
            })
          });
        }
      }
    }
    this.setState({ tips });
  };

  getDependentRecords = selectedRecord => {
    let dependentRecords = [];
    if (selectedRecord && !Util.isEmpty(selectedRecord["dependents"])) {
      dependentRecords = Util.clone(selectedRecord["dependents"]);
    }
    return dependentRecords;
  };

  handleEmployeeDataChange = (name, value) => {
    const { tips } = this.state;
    if (name === "category") {
      if (this.props.mode === MODE.EDIT) {
        this.setTips(TIPS_CODE.CHANGE_CATEGORY, this.originalValues.category !== value);
      }
    }
  };

  handleDependentTermination = () => {
    const { tips } = this.state;
    this.setTips(TIPS_CODE.TERMINATE_DEPENDENT);
  };

  //need to call confirm before submit
  handleSubmitCompleted = (mode, employee, dependents) => {
    //cache and call confirm
    this.submitData = {
      member: employee,
      dependents: dependents
    };

    // Check if any dependants have coverage_end_date set
    const dependantsWithEndDate = (dependents || []).filter(
      d => d.coverage_end_date
    );

    if (dependantsWithEndDate.length > 0) {
      // Show dependant confirmation dialog first
      this.setState({
        dependantConfirmDialog: true,
        dependantsWithEndDate
      });
    } else {
      // No dependants with end date, go straight to submit confirm
      this.handleConfirm();
    }
  };

  // Error codes that should be shown inline using server error message
  SERVER_MESSAGE_ERROR_CODES = ["MM_ERR_100","MM_ERR_101","MM_ERR_102","MM_ERR_103","MM_ERR_104"];

  //Check if error code should be shown inline (like email exist error)
  isInlineError = (errorCode) => {
    return this.SERVER_MESSAGE_ERROR_CODES.includes(errorCode);
  };

  // Get error message - use server message for certain codes, otherwise use mapped message
  getInlineErrorMessage = (errorCode, serverMessage) => {
    if (this.SERVER_MESSAGE_ERROR_CODES.includes(errorCode)) {
      return serverMessage; // ERR_001: use server message
    }
  };

  //Handle error dialog OK button click - close dialog and show inline error
  handleServerErrorDialogClose = () => {
    this.setState({
      serverErrorDialog: false,
      inlineError: this.state.serverErrorMessage,
      serverErrorMessage: null
    });
  };

  handleSubmitAfterConfirmed = () => {
    this.props.showLoading(true);
    const { mode, addEmployee, updateEmployee } = this.props;
    let submitData = this.submitData;
    if (mode === MODE.ADD) {
      addEmployee(submitData).then(
        response => {
          this.setState({ systemEmailExist: false });
          this.props.showLoading(false);
          this.props.handleClose();
        },
        error => {
          this.props.showLoading(false);
          const errorCode = error.data?.error;

          if (error.message === "Duplicated email found") {
            // Existing email error handling
            this.setState({ confirmSubmitDialog: false });
            this.setState({ systemEmailExist: true });
          } else if (errorCode && this.isInlineError(errorCode)) {
            //Handle other inline errors by error code
            this.setState({
              confirmSubmitDialog: false,
              serverErrorDialog: true,
              serverErrorMessage: this.getInlineErrorMessage(errorCode, error.message)
            });
          } else {
            this.props.handleClose();
            this.props.handleEmployeeError(error);
          }
        }
      );
    } else if (mode === MODE.EDIT) {
      updateEmployee(submitData, this.originalValues.category).then(
        response => {
          this.setState({ systemEmailExist: false });
          this.props.showLoading(false);
          this.props.handleClose();
          this.props.myEmployee.data.map(person => {
            if (person.person_id === response.data.member.id) {
              (person.bank_name = response.data.member.bank_name),
                (person.bank_account_name = response.data.member.bank_account_name),
                (person.bank_account_number = response.data.member.bank_account_number),
                (person.bank_code = response.data.member.bank_code),
                (person.branch_code = response.data.member.branch_code);
            }
          });
        },
        error => {
          this.props.showLoading(false);
          const errorCode = error.data?.error;
          const serverMessage = error.data?.message || error.message;

          if (error.message === "Duplicated email found") {
            this.setState({ confirmSubmitDialog: false });
            this.setState({ systemEmailExist: true });
          } else if (errorCode && this.SERVER_MESSAGE_ERROR_CODES.includes(errorCode)) {
            this.setState({
              confirmSubmitDialog: false,
              serverErrorDialog: true,
              serverErrorMessage: serverMessage
            });
          } else {
            this.props.handleClose();
            this.props.handleEmployeeError(error);
          }
        }
      );
    }
    // this.props.handleClose();
  };

  //handle confirm dialog button
  handleConfirm = () => {
    this.setState({ confirmSubmitDialog: true });
  };

  handleDependantConfirm = () => {
    // User confirmed dependant coverage end date, proceed to submit confirm
    this.setState({ dependantConfirmDialog: false });
    this.handleConfirm();
  };

  handleDependantCancel = () => {
    this.setState({ dependantConfirmDialog: false });
  };

  render() {
    const { mode, open, readOnly, handleClose, selectedIndex, selectedRecord, categories, policyDetails } = this.props;
    const { tips, inlineError, serverErrorDialog, serverErrorMessage, dependantConfirmDialog, dependantsWithEndDate} = this.state;
    return (
      <Fragment>
        <EmployeeEditDialog
          mode={mode}
          open={open}
          handleClose={handleClose}
          selectedIndex={selectedIndex}
          selectedRecord={selectedRecord}
          systemEmailExist={this.state.systemEmailExist}
          inlineError={inlineError}
          getDependentRecords={this.getDependentRecords.bind(this)}
          handleSubmitCompleted={this.handleSubmitCompleted.bind(this)}
          handleEmployeeDataChange={this.handleEmployeeDataChange.bind(this)}
          handleDependentTermination={this.handleDependentTermination.bind(this)}
          categories={categories}
          readOnly={readOnly}
          tips={tips}
          isRenewalSubmitted={policyDetails?.policy?.renewal_submitted}
        />

        <Dialog
          open={serverErrorDialog}
          onClose={this.handleServerErrorDialogClose}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle disableTypography>
            <Typography style={{ color: "#ED1C24", fontWeight: "bold", fontSize: "1.1em" }}>
              Alert Message
            </Typography>
          </DialogTitle>
          <DialogContent>
            {serverErrorMessage && serverErrorMessage.split("\n").filter(line => line.trim() !== "").map((line, index) => (
              <Typography key={index} variant="body1" color="textSecondary" style={{ marginBottom: 8 }}>
                {line}
              </Typography>
            ))}
          </DialogContent>
          <DialogActions style={{ marginBottom: 20 }}>
            <Button
              onClick={this.handleServerErrorDialogClose}
              color="primary"
              variant="contained"
              style={{ width: 130 }}
            >
              OK
            </Button>
          </DialogActions>
        </Dialog>

        <ConfirmMessageDialog
          name="confirm-employee"
          title="Submit Changes"
          description="By submitting the information of the insured members and/or their dependents to Prudential herein I hereby acknowledge and confirms that the information is true, complete and accurate, and shall form the basis of my/our contract with Prudential. I/We further acknowledge and agree that Prudential can request supporting documents in relation to the information provided above.~Further I acknowledge and confirm that I have obtained the necessary consent from the insured members and/or their dependents to collect, use, disclose and process such information to Prudential. I/We agree to indemnify Prudential against any losses, damages, costs or liabilities arising from any false, incomplete or inaccurate information, or any breach of the consent requirement."
          open={this.state.confirmSubmitDialog}
          closeHandler={() => {
            this.setState({ confirmSubmitDialog: false });
          }}
          confirmHandler={this.handleSubmitAfterConfirmed.bind(this)}
          confirmButtonText="Submit"
          closeButtonText="Cancel"
          isCheckbox={true}
          checkboxLabel="I confirm that the information provided is accurate and that I have obtained necessary authorization from the insured."
        />

        {/* Dependant Coverage End Date Confirmation Dialog */}
        <Dialog open={dependantConfirmDialog} onClose={this.handleDependantCancel} maxWidth="xs" fullWidth>
          <DialogContent>
            <Typography style={{ color: "#ED1C24", fontWeight: "bold", fontSize: "1.1em", marginBottom: 12 }}>
              Confirmation
            </Typography>
            {dependantsWithEndDate.map((d, index) => (
              <Typography key={index} variant="body1" style={{ marginBottom: 8 }}>
                The last date of coverage for dependant{" "}
                {d.full_name || d.name} is on{" "}
                {d.coverage_end_date}.
              </Typography>
            ))}
          </DialogContent>
          <DialogActions style={{ display: "flex", justifyContent: "center", marginBottom: 20 }}>
            <Button
              onClick={this.handleDependantCancel}
              color="primary"
              style={{ width: 130 }}
            >
              Cancel
            </Button>
            <Button
              onClick={this.handleDependantConfirm}
              color="primary"
              variant="contained"
              style={{ width: 130 }}
              autoFocus
            >
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
      </Fragment>
    );
  }
}

const styles = theme => ({});

function mapStateToProps(state, prop) {
  return {
    myEmployee: state.HR.myemployee,
    categories: state.HR.coverage.policy.data.categories
  };
}

function mapDispatchToProps(dispatch) {
  return { ...bindActionCreators(myEmployeeActions, dispatch) };
}

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(withStyles(styles, { withTheme: true })(MyEmployeeDialog))
);
